<mat-sidenav-container class="sidenav-container">
  <mat-sidenav #sidenav mode="side" class="sidenav">
    <div class="top-content">
      <button mat-icon-button (click)="toggle360View()" class="sideNav-button" matTooltip="Vista 360"
        [matTooltipPosition]="'left'"
        *ngIf="projectEnvironment.modules.view360 && !homeComponent.activatedViewDashboard">
        <img src="assets/img/SVG/360Icon.svg"
          [class]="homeComponent.activatedViewPanoramic? 'icon-activated': 'icon'" />
      </button>
      
      <button mat-icon-button class="widgetButton" class="sideNav-button" (click)="viewMapPot()" matTooltip="Ver POT"
        [matTooltipPosition]="'left'"
        *ngIf="projectEnvironment.modules.mapPot && !homeComponent.activatedViewDashboard">
        <img class="icon" src="assets/img/SVG/potIcon.svg" />
      </button>
      <!-- <button mat-icon-button class="widgetButton" class="sideNav-button" (click)="viewMapFact()" matTooltip="Ver Facturación"
        [matTooltipPosition]="'left'"
        *ngIf="projectEnvironment.modules.mapPot && !homeComponent.activatedViewDashboard">
        <img class="icon" src="assets/img/PREDIAL.svg" /> -->
      <!-- </button> -->
      <button mat-icon-button (click)="viewDashboard()" class="sideNav-button"
        matTooltip="Ver avance de facturación" [matTooltipPosition]="'left'"
        *ngIf="projectEnvironment.modules.dashboard">
        <img class="icon" src="assets/img/PREDIAL.svg" />
      </button>
    </div>

    <div class="footer-content">
      <div class="menu-icon">
        <button mat-icon-button class="sideNav-button" [matMenuTriggerFor]="menuLogin">
          <img src="assets/img/SVG/infoIcon.svg" class="icon" />
        </button>
      </div>
    </div>
  </mat-sidenav>
</mat-sidenav-container>

<mat-menu #menuLogin="matMenu" [xPosition]="'before'">
  <div class="menu-title">
    <mat-icon>{{projectEnvironment.login?'person':'public'}}</mat-icon>
    <h3>{{projectEnvironment.login? loginService.userName+' '+loginService.userLastname:project}}</h3>
  </div>
  <div class="menu-content">
    <button mat-button *ngIf="projectEnvironment.login && loginService.getUserRol()=='Administrador'"
      class="footer-button" (click)="openSettingsLayer()">
      <span>Configuración</span>
      <mat-icon class="footer-button-icon">settings</mat-icon></button>
    <button mat-button class="footer-button" (click)="openUserManual()">
      <span>Ayuda</span>
      <mat-icon class="footer-button-icon">help_outline</mat-icon></button>
    <button mat-button *ngIf="projectEnvironment.login" class="footer-button" (click)="reload()">
      <span>Cerrar sesión</span>
      <mat-icon class="footer-button-icon">logout</mat-icon></button>
    <span *ngIf="projectEnvironment.login" style="font-size: small;">{{project}}</span>
    <span style="font-size: small;">RealGIS v. {{version}}</span>
    <span style="font-size: x-small; font-style: italic;">
      Powered by
      <a href="https://realtix.co/wordpress/"> Realidad 5.0</a>
    </span>
  </div>
</mat-menu>